import React from "react";
import styled from "styled-components";
import { macOSCheck } from "../../../../util/macOSCheck";

const LineSeedKrBd = (props) => {
  return <LineSeedKrBdWrapper isMac={macOSCheck()} {...props} />;
};

export default LineSeedKrBd;

const LineSeedKrBdWrapper = styled.div`
  font-family: "LINESeedKR-Bd";

  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  display: block;
  word-break: keep-all;
  white-space: pre-wrap;

  margin-top: ${(props) => (props.isMac ? "0" : "2px")};
`;
